// -------------------------------------
// Dependencies
// -------------------------------------
// Styles
import './_contact-form.scss';


document.addEventListener("DOMContentLoaded", function() {
    // Attach to the form submission event
    var contactForm = document.querySelector(".contact-form #main_form");
    
    if (!contactForm) return false;
    
    contactForm.addEventListener("submit", function(event) {
        event.preventDefault(); // Prevent the form from submitting initially

        // Check if the recaptcha was solved correctly
        var recaptchaResponse = grecaptcha.getResponse();
        var recaptchaError = contactForm.querySelector('#g-recaptcha-error');
        recaptchaError.style.display = 'none';
        if (recaptchaResponse.length == 0) {
            // If the user didn't populate the captcha, display an error message
            recaptchaError.style.display = 'block';
            return;
        }
        
        // If the user solved the recaptcha, remove the "required" attribute from #custevent_street_address
        var streetAddressInput = document.getElementById("custevent_street_address");
        streetAddressInput.removeAttribute("required");
      
        // Copy the recatcha token to the g-token field
        var gtokenInput = document.getElementById("custevent_g_token");
        gtokenInput.value = recaptchaResponse;

        // Replace Action if Necessary
        if (!(typeof process === 'object' && typeof require === 'function')) {
            var dest1 = "aHR0cHM6Ly80MTMxMzAyLmV4dGZvcm1zLm5ldHN1aXRlLmNvbS9hcHAvc2l0ZS9jcm0vZXh0ZXJuYWxjYXNlcGFnZS5ubA==";
            var dest2 = "P2NvbXBpZD00MTMxMzAyJmFtcDtmb3JtaWQ9MTgmYW1wO2g9QUFGZGlrYUlJSkVWYlR5dE0zdDlYSE5jcTRSRmtOQlVpY3NsZUJyRlo5SF9EdDhHUmVz";
            contactForm.setAttribute("action", atob(dest1)+atob(dest2));
        }
        
        // Submit the form
        contactForm.submit();
    });
});
